import withDeleteService from './with-delete-service';

export default withDeleteService;
